<template>
  <div class="bookIntro">
    <!-- <img class="big-img" src="@/assets/Frame 594 (2).png" alt=""> -->
    <!-- 顶部大图片 -->
    <imgBigCards ></imgBigCards>

    <!-- 白色区域 -->
    <div class="box-white">
      <textBar :titles="getCategoryText(12) || ''"></textBar>
      <writingCardCarousel
        :dataArr="mydata.bookListData1"
      ></writingCardCarousel>
      <writingCardsBig
        :dataArrL="mydata.bookListData2"
        :dataArrR="mydata.bookListData3"
        style="margin-top: 67px"
        :titleL="getCategoryText(13) || ''"
        :titleR="getCategoryText(14) || ''"
      ></writingCardsBig>
    </div>
    <!-- 绿色区域 -->
    <div class="box-green">
      <div class="green-inside">
        <textBar
          :titles="getCategoryText(15) || ''"
          style="margin-left: 16px"
        ></textBar>
        <!-- 插件swiper区域 -->
        <div>
          <swiper
            v-if="mydata.bookListData4.length"
            direction="horizontal"
            class="inside-cardBox"
            :slidesPerView="
              mydata.bookListData4.length >= 2 ? 2 : mydata.bookListData4.length
            "
            loop
            :autoplay="{ delay: 3000, disableOnInteraction: true }"
            :navigation="false"
            :pagination="{ clickable: true }"
            :scrollbar="{ draggable: true }"
            :space-between="0"
            :centeredSlides="false"
            :modules="modules"
            effect="coverflow"
            @swiper="onSwiper"
            @mouseenter="enter"
            @mouseleave="leave"
            @slideChange="onSlideChange"
          >
            <swiper-slide
              v-for="(item, index) in mydata.bookListData4"
              :key="index"
              class="book-cards column-book1"
              style="margin: 0"
            >
              <columnBookCards class="column-book1" :info="item">
                <!-- <template #columnBook>
                  <img class="big-img" v-complete:src="item.img_url" alt="" />
                </template> -->
              </columnBookCards>
            </swiper-slide>
          </swiper>
        </div>
        <!-- <el-button
          class="l-btn huibian"
          :icon="ArrowLeft"
          circle
          @click="rightClick"
        ></el-button>
        <el-button
          class="r-btn"
          :icon="ArrowRight"
          circle
          @click="leftClick"
        ></el-button> -->
      </div>
    </div>

    <!-- 黄色区域 -->
    <div class="box-blue">
      <textBar class="text-blue" :titles="getCategoryText(16) || ''"></textBar>
      <div class="box-background">
        <div class="box-footplate">
          <div class="box-column">
            <!-- 插件swiper区域 -->
            <div style="width: 343px" class="box-column">
              <swiper
                v-if="mydata.bookListData5.length"
                direction="horizontal"
                class="inside-cardBox"
                :slidesPerView="
                  mydata.bookListData5.length >= 2
                    ? 2
                    : mydata.bookListData5.length
                "
                loop
                :autoplay="{ delay: 3000, disableOnInteraction: true }"
                :navigation="false"
                :pagination="{ clickable: true }"
                :scrollbar="{ draggable: true }"
                :space-between="0"
                :centeredSlides="false"
                :modules="modules_1"
                effect="coverflow"
                @swiper="onSwiper_1"
                @mouseenter="enter_1"
                @mouseleave="leave_1"
                @slideChange="onSlideChange_1"
              >
                <swiper-slide
                  v-for="(item, index) in mydata.bookListData5"
                  :key="index"
                  class="book-cards column-book2"
                  style="margin: 0"
                >
                  <columnBookCards class="column-book2" :info="item">
                    <!-- <template #columnBook>
                      <img class="big-img" v-complete:src="item.img_url" alt="" />
                    </template> -->
                    <template #line>
                      <div
                        style="
                          width: 35px;
                          border: 1px solid #999999;
                          margin: 10px 0px;
                        "
                      ></div>
                    </template>
                  </columnBookCards>
                </swiper-slide>
              </swiper>
              <!-- <el-button
                class="l-btn zhuanxiang"
                :icon="ArrowLeft"
                circle
                @click="rightClick_1"
              ></el-button>
              <el-button
                class="r-btn"
                :icon="ArrowRight"
                circle
                @click="leftClick_1"
              ></el-button> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 青色区域 -->
    <div class="box-cyan">
      <div class="cyan-background">
        <div class="box-button">
          <div
            class="box-itemButton"
            v-for="(item, index) in mydata.buttonTitle"
            :key="index"
          >
            <el-button
              type="success"
              :plain="item !== mydata.buttonTitleActive"
              @click="buttonTitleClick(item)"
              >{{ item }}</el-button
            >
          </div>
        </div>

        <!-- 插件swiper区域-原创卷学考类同步类工具类 -->
        <div class="box-columnBookCards">
          <swiper
            v-if="mydata.bookListData6.length"
            direction="horizontal"
            class="inside-cardBox"
            :slidesPerView="
              mydata.bookListData6.length >= 2 ? 2 : mydata.bookListData6.length
            "
            loop
            :autoplay="{ delay: 3000, disableOnInteraction: true }"
            :navigation="false"
            :pagination="{ clickable: true }"
            :scrollbar="{ draggable: true }"
            :space-between="0"
            :centeredSlides="false"
            :modules="modules_2"
            effect="coverflow"
            @swiper="onSwiper_2"
            @mouseenter="enter_2"
            @mouseleave="leave_2"
            @slideChange="onSlideChange_2"
            :slidesOffsetBefore="0"
            :slidesOffsetAfter="0"
            :spaceBetween="0"
          >
            <swiper-slide
              v-for="(item, index) in mydata.bookListData6"
              :key="index"
              style="margin: 0"
            >
              <columnBookCards2 class="column-book3" :info="item">
                <!-- <template #columnBook>
                  <img class="big-img" v-complete:src="item.img_url" alt="" />
                </template> -->
                <template #line>
                  <div
                    style="
                      width: 35px;
                      border: 1px solid #ffffff99;
                      margin: 10px 0px;
                    "
                  ></div>
                </template>
              </columnBookCards2>
            </swiper-slide>
          </swiper>
          <!-- <el-button
            class="l-btn"
            :icon="ArrowLeft"
            circle
            @click="rightClick_2"
          ></el-button>
          <el-button
            class="r-btn"
            :icon="ArrowRight"
            circle
            @click="leftClick_2"
          ></el-button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getBookListData } from "@/utils/commonApi.js";
// import modelTestsCard from "@/components/modelTestsCard/index.vue";
//图书分类接口
import { getCategoryList } from "@/api/bookIntro/index.js";

// import subjectButton from "@/components/subjectButton/index.vue";
import imgBigCards from "@/components/imgBigCards/index.vue";

import textBar from "@/components/textBar/index.vue";
import writingCardCarousel from "@/components/writingCardCarousel/index.vue";
import writingCardsBig from "@/components/writingCardsBig/index.vue";

// import columnBookCards from "@/components/columnBookCards/index.vue";
import columnBookCards from "../components/columnBookCards.vue";

// import columnBookCards2 from "@/components/columnBookCards2/index.vue";
import columnBookCards2 from "../components/columnBookCards2.vue";

import { nextTick, reactive, ref, toRaw } from "vue";
import { ArrowLeft, ArrowRight } from "@element-plus/icons-vue";

//swiper start//////////////////////////////////////////////////////////////////////////////////////////////
// 引入swiper插件
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
import {
  Autoplay,
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
} from "swiper/modules";

// 如果一个页面有多次使用的话，注意这些变量名方法名再复制一份 start////////////////
// 创建功能模块
let modules = [Autoplay, Navigation, Pagination, Scrollbar, A11y];
//定义swiperNew,目的获取非响应式swiper
let swiperNew = null;
// 事件处理器
const onSwiper = (swiper) => {
  swiperNew = toRaw(swiper); //拿到swiper对象再转换为非响应式
};
//鼠标移入
const enter = () => {
  swiperNew.autoplay.stop();
};
//鼠标移出
const leave = () => {
  swiperNew.autoplay.start();
};
// 点击右箭头
const rightClick = () => {
  nextTick(() => {
    swiperNew.slidePrev();
  });
};
// 点击左箭头
const leftClick = () => {
  nextTick(() => {
    swiperNew.slideNext();
  });
};
// 单元块滑动
const onSlideChange = () => {};
// 如果一个页面有多次使用的话，注意这些变量名方法名再复制一份 end////////////////

// 如果一个页面有多次使用的话，注意这些变量名方法名再复制一份 start////////////////
// 创建功能模块
let modules_1 = [
  Autoplay,
  Navigation,
  // Pagination,
  Scrollbar,
  A11y,
];
//定义swiperNew,目的获取非响应式swiper
let swiperNew_1 = null;
// 事件处理器
const onSwiper_1 = (swiper) => {
  swiperNew_1 = toRaw(swiper); //拿到swiper对象再转换为非响应式
};
//鼠标移入
const enter_1 = () => {
  swiperNew_1.autoplay.stop();
};
//鼠标移出
const leave_1 = () => {
  swiperNew_1.autoplay.start();
};
// 点击右箭头
const rightClick_1 = () => {
  nextTick(() => {
    swiperNew_1.slidePrev();
  });
};
// 点击左箭头
const leftClick_1 = () => {
  nextTick(() => {
    swiperNew_1.slideNext();
  });
};
// 单元块滑动
const onSlideChange_1 = () => {};
// 如果一个页面有多次使用的话，注意这些变量名方法名再复制一份 end////////////////

// 如果一个页面有多次使用的话，注意这些变量名方法名再复制一份 start////////////////
// 创建功能模块
let modules_2 = [
  Autoplay,
  Navigation,
  //Pagination,
  Scrollbar,
  A11y,
];
//定义swiperNew,目的获取非响应式swiper
let swiperNew_2 = null;
// 事件处理器
const onSwiper_2 = (swiper) => {
  swiperNew_2 = toRaw(swiper); //拿到swiper对象再转换为非响应式
};
//鼠标移入
const enter_2 = () => {
  swiperNew_2.autoplay.stop();
};
//鼠标移出
const leave_2 = () => {
  swiperNew_2.autoplay.start();
};
// 点击右箭头
const rightClick_2 = () => {
  nextTick(() => {
    swiperNew_2.slidePrev();
  });
};
// 点击左箭头
const leftClick_2 = () => {
  nextTick(() => {
    swiperNew_2.slideNext();
  });
};
// 单元块滑动
const onSlideChange_2 = () => {};
// 如果一个页面有多次使用的话，注意这些变量名方法名再复制一份 end////////////////

//swiper end//////////////////////////////////////////////////////////////////////////////////////////////

const mydata = reactive({
  // buttonTitle: ["原创卷", "学考类", "同步类", "工具类"],
  // buttonTitleActive: "原创卷",
  buttonTitle: [],
  buttonTitleActive: "",
  bookListData1: [], //高中-专题类
  bookListData2: [], //高中-真题类
  bookListData3: [], //高中-真题汇编
  bookListData4: [], //高中-汇编类
  bookListData5: [], //高中-专项类
  bookListData6: [], //高中-["原创卷", "学考类", "同步类", "工具类"]

  getCategoryArr: [], //图书分类
  getCategoryArrId: [12, 13, 14, 15, 16, 17, 18, 19, 20],
});

//图书分类接口
function getCategoryFn() {
  getCategoryList().then((res) => {
    // console.log(res.data, "图书分类");
    mydata.getCategoryArr = res.data;
    // 获取四个单选框按钮的文字以及当前激活的单选框按钮的文字
    mydata.buttonTitle = [
      getCategoryText(17),
      getCategoryText(18),
      getCategoryText(19),
      getCategoryText(20),
    ];
    mydata.buttonTitleActive = mydata.buttonTitle[0];
  });
}
getCategoryFn();

// 获取图书分类的文字
function getCategoryText(id) {
  let obj = mydata.getCategoryArr.find((item) => {
    return item.id === id;
  });
  return obj?.name;
}

// 高中-专题类
getBookListData(9, 12).then((res) => {
  // getBookListData().then((res) => {
  mydata.bookListData1 = res.data.list.map((item) => {
    item.path = item.buy_url_jd || item.buy_url;
    item.outPage = true;
    return item;
  });
  // console.log(res.data.list,"高中-专题类")
});

// 高中-真题类
getBookListData(9, 13).then((res) => {
  // getBookListData().then((res) => {
  mydata.bookListData2 = res.data.list.map((item) => {
    item.path = item.buy_url_jd || item.buy_url;
    item.outPage = true;
    return item;
  });
  // console.log(res.data.list,"高中-真题类")
});

// 高中-真题汇编
getBookListData(9, 14).then((res) => {
  // getBookListData().then((res) => {
  mydata.bookListData3 = res.data.list.map((item) => {
    item.path = item.buy_url_jd || item.buy_url;
    item.outPage = true;
    return item;
  });
  // console.log(res.data.list,"高中-真题汇编")
});

// 高中-汇编类
getBookListData(9, 15).then((res) => {
  // getBookListData().then((res) => {
  mydata.bookListData4 = res.data.list.map((item) => {
    item.path = item.buy_url_jd || item.buy_url;
    item.outPage = true;
    return item;
  });
  // console.log(res.data.list,"高中-汇编类")
});

// 高中-专项类
getBookListData(9, 16).then((res) => {
  // getBookListData().then((res) => {
  mydata.bookListData5 = res.data.list.map((item) => {
    item.path = item.buy_url_jd || item.buy_url;
    item.outPage = true;
    return item;
  });
  // console.log(res.data.list,"高中-专项类")
});

// 高中-["原创卷", "学考类", "同步类", "工具类"]
getBookListData(9, 17).then((res) => {
  // getBookListData().then((res) => {
  mydata.bookListData6 = res.data.list.map((item) => {
    item.path = item.buy_url_jd || item.buy_url;
    item.outPage = true;
    return item;
  });
  // console.log(res.data.list,"原创卷", "学考类", "同步类", "工具类")
});

function buttonTitleClick(item) {
  mydata.buttonTitleActive = item;
  // 高中-["原创卷", "学考类", "同步类", "工具类"]
  let cate_id = "";
  if (mydata.buttonTitleActive === "原创卷") {
    cate_id = 17;
  }
  if (mydata.buttonTitleActive === "学考类") {
    cate_id = 18;
  }
  if (mydata.buttonTitleActive === "同步类") {
    cate_id = 19;
  }
  if (mydata.buttonTitleActive === "工具类") {
    cate_id = 20;
  }
  getBookListData(9, cate_id).then((res) => {
    // getBookListData().then((res) => {
    mydata.bookListData6 = res.data.list.map((item) => {
      item.path = item.buy_url_jd || item.buy_url;
      item.outPage = true;
      return item;
    });
  });
}
</script>

<style scoped lang="scss">
// :deep(.bookIntro > .box-green[data-v-4e942a3e] .swiper-button-prev::after){
//   background: red !important;
// }

// :deep(.el-carousel__indicator.el-carousel__indicator--horizontal){
//   display:none;
// }

.bookIntro {
  // background-color: #F7F7F7;
  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 200px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }

  ////////白色区域
  > .box-white {
    width: 100%;
    // height: 1290px;
    // border:1px solid rgb(68, 0, 255);
    margin: 0 auto;
    overflow: hidden;
    background-color: #f7f7f7;
    margin-bottom: 24px;
  }
  ////////绿色区域
  > .box-green {
    width: 100%;
    // height: 605px;
    padding: 16px 0px;
    // border:1px solid rgb(255, 94, 0);
    margin: 0 auto;
    background-color: #09ab3e;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    //////装所有图书卡片组件的小区域
    .green-inside {
      width: 343px;
      // height: 525px;
      position: relative;
      // border: 1px solid rgb(255, 94, 0);
      margin: 0 auto;
      border-radius: 8px;
      background: linear-gradient(
        110.52deg,
        rgba(246, 246, 250, 0.4) -1.14%,
        rgba(81, 83, 103, 0) 102.14%
      );
      // overflow: hidden;
      display: flex;
      flex-direction: column;

      //////图书卡片组件
      .inside-cardBox {
        display: flex;
        flex-shrink: 0 !important;
        :deep(.column-book1) {
          margin: 0px 11px;
          flex-shrink: 0;
          // border:1px solid red;
          // .big-img {
          //  margin-left:65px;
          //  margin-top:40px;
          // }
          .back-box {
            border-radius: 8px 8px 0px 0px;
          }
          .box-content {
            width: 150px;
            height: 125px;
            padding: 10px;
            margin-top: 0px;
            border-radius: 0px 0px 8px 8px;
            // background-color: #c9cdcb8a;
            background: linear-gradient(180deg, #b3b6b58a 10.06%, #e2f1f5 100%);
            > p:nth-of-type(1) {
              font-size: 16px;
              font-weight: 400;
              color: #333333;
              white-space: nowrap !important; //不折行
              text-overflow: ellipsis !important; //文本溢出 用省略号显示
              overflow: hidden !important;
            }
            > p:nth-of-type(2) {
              // height:%;
              font-size: 14px;
              font-weight: 400;
              color: #666666;
              line-height: 24px;
              display: -webkit-box;
              -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
              text-overflow: ellipsis; //文本溢出 用省略号显示
              -webkit-line-clamp: 3; //几行
              overflow: hidden;
            }
          }
        }
        :deep(.swiper-wrapper) {
          // border: 1px solid red;
          // margin-top:100px;
          height: 320px;
        }
      }
      //
      // :deep(.swiper-slide.book-cards.column-book1){
      //   border:1px solid rgb(0, 30, 255);
      //   height:280px;
      // }
      :deep(
          .swiper.swiper-initialized.swiper-horizontal.swiper-ios.inside-cardBox
        ) {
        height: 298px;
      }
    }

    /////////两边箭头
    // :deep(.swiper-button-prev::after) {
    //   //  border:1px solid red;
    //   margin-left: -29px;
    //   color: rgba(255, 255, 255, 0.5);
    //   font-size: 25px;
    //   margin-top: -100px;
    // }
    // :deep(.swiper-button-next::after) {
    //   margin-right: -32px;
    //   color: rgba(255, 255, 255, 0.5);
    //   font-size: 25px;
    //   margin-top: -100px;
    // }
    //////////
    // :deep(
    //     .swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets.swiper-pagination-horizontal
    //   ) {
    //   // margin-bottom:-50px;
    //   // border:1px solid red;
    // }
    // :deep(.swiper.swiper-initialized.swiper-horizontal.inside-cardBox) {
    //   // border: 1px solid rgb(0, 102, 255);
    //   // margin-top:100px;
    // }
    :deep(.swiper-wrapper) {
      // border: 1px solid rgb(255, 0, 242);
      // margin:0 auto;

      // width: 1250;
      height: 440px;
      // margin-top:100px;
    }

    .l-btn {
      position: absolute;
      z-index: 9999;
      color: #ffffff;
      font-size: 20px;
      border: 1px solid #ffffff;
      width: 25px;
      height: 25px;
      border-radius: 100%;
      line-height: 25px;
      text-align: center;
      top: 45%;
      left: 0px;
      background: transparent;
    }

    .r-btn {
      position: absolute;
      z-index: 9999;
      color: #ffffff;
      font-size: 20px;
      border: 1px solid #ffffff;
      width: 25px;
      height: 25px;
      border-radius: 100%;
      line-height: 25px;
      text-align: center;
      top: 45%;
      right: 0px;
      background: transparent;
    }
  }

  // /////////两边箭头
  // :deep(.swiper-button-prev::after){
  //       //  border:1px solid red;
  //        margin-left:-22px;
  //        color:rgba(255,255,255,0.5);
  //        font-size:25px;
  //        margin-top:-100px;
  // }
  // :deep(.swiper-button-next::after){
  //        margin-right:-25px;
  //        color:rgba(255,255,255,0.5);
  //        font-size:25px;
  //        margin-top:-100px;
  // }

  ////////黄色区域
  > .box-blue {
    width: 100%;
    // height: 759px;
    // border:1px solid rgb(179, 255, 0);
    margin: 0 auto;
    // background-color: #09AB3E;
    background-image: url("@/assets/Frame 191150.png");
    overflow: hidden;
    padding-bottom: 24px;
    ////////textBar组件
    :deep(.text-blue) {
      > p {
        // color: #ffffff;
      }
      // margin-bottom: 120px;
    }
    ////圆角背景色
    > .box-background {
      // background-image: url("@/assets/Rectangle 1126.png");
      // position:absolute;
      // z-index: 5;
      width: 343px;
      // height: 450px;
      margin: 0 auto;
      // width: 1469px;
      // height: 450px;
      // margin: 0 auto;
      // border: 1px solid #ffffff;
      // border-radius: 50px;
      // // overflow:hidden;
      position: relative;
      // background: linear-gradient(
      //   110.52deg,
      //   rgba(9, 171, 62, 0.7) -1.14%,
      //   rgba(9, 171, 62, 0.7) 102.14%
      // );

      ///////放图书的“长方形台子”
      // > .box-footplate {
      //   background-image: url("@/assets/Group 158.png");
      //   width: 1200px;
      //   height: 225px;
      //   margin: 0 auto;
      //   margin-top: 165px;
      //   position: relative;

      //   ///////装所有图书卡片的区域
      //   > .box-column {
      //     display: flex;
      //     justify-content: space-between;
      //     width: 908px;
      //     // height: 422px;
      //     // border: 1px solid red;
      //     margin: auto;
      //     position: absolute;
      //     bottom: 30px;
      //     left: 50%;
      //     transform: translateX(-50%);
      /////图书卡片组件
      :deep(.column-book2) {
        width: 166px;
        // height: 422px;
        // border: 1px solid blue;
        flex-shrink: 0;
        overflow: hidden; /* 确保超出容器的内容被裁剪 */
        // white-space: nowrap; /* 确保文本在一行内显示 */
        text-overflow: ellipsis; /* 超出部分显示省略号 */
        margin: 0 2px;
        // .big-img {
        //   width: 100%;
        //   height: 272px;
        //   margin-bottom: 30px;
        //   box-shadow: 0px 4px 4px 0px #00000040;
        //   border-radius: 8px;
        // }
        .back-box {
          width: 166px;
          height: 166px;
          border-radius: 8px 8px 0px 0px;
        }
        .box-content {
          width: 166px;
          height: 140px;
          padding: 10px;
          margin-top: 0px;
          border-radius: 0px 0px 8px 8px;
          // background-color: #c9cdcb8a;
          background: linear-gradient(180deg, #f7e05f 10.06%, #e2f1f5 100%);
          > p:nth-of-type(1) {
            font-size: 16px;
            font-weight: 400;
            color: #333333;
            white-space: nowrap !important; //不折行
            text-overflow: ellipsis !important; //文本溢出 用省略号显示
            overflow: hidden !important;
          }
          > p:nth-of-type(2) {
            // height:%;
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            line-height: 24px;
            display: -webkit-box;
            -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
            text-overflow: ellipsis; //文本溢出 用省略号显示
            -webkit-line-clamp: 3; //几行
            overflow: hidden;
          }
        }
      }
      //   }
      // }
    }

    /////////两边箭头
    // :deep(.swiper-button-prev::after) {
    //   //  border:1px solid red;
    //   margin-left: -30px;
    //   color: rgba(255, 255, 255, 0.5);
    //   font-size: 25px;
    //   margin-top: -150px;
    // }
    // :deep(.swiper-button-next::after) {
    //   margin-right: -30px;
    //   color: rgba(255, 255, 255, 0.5);
    //   font-size: 25px;
    //   margin-top: -150px;
    // }

    // :deep(.swiper-wrapper) {
    //   // border: 1px solid blue;
    //   height: 528px;
    // }
    .l-btn {
      position: absolute;
      z-index: 9999;
      color: #ffffff;
      font-size: 20px;
      border: 1px solid #ffffff;
      width: 25px;
      height: 25px;
      border-radius: 100%;
      line-height: 25px;
      text-align: center;
      top: 40%;
      left: 0px;
      background: transparent;
    }

    .r-btn {
      position: absolute;
      z-index: 9999;
      color: #ffffff;
      font-size: 20px;
      border: 1px solid #ffffff;
      width: 25px;
      height: 25px;
      border-radius: 100%;
      line-height: 25px;
      text-align: center;
      top: 40%;
      right: -0px;
      background: transparent;
    }
  }

  ////////青色区域
  > .box-cyan {
    width: 100%;
    //height: 661px;
    // border:1px solid rgb(179, 255, 0);
    margin: 0 auto;
    background-color: #d8f5e1;
    // background-image: url("@/assets/Rectangle 1131.png");
    overflow: hidden;
    ///////装图书组件 和 按钮的大盒子
    .cyan-background {
      width: 343px;
      // height: 565px;
      // border: 1px solid rgb(179, 255, 0);
      margin: 0 auto;
      // border: 1px solid #031402;
      margin-top: 24px;
      // margin-bottom:30px;
      display: flex;
      flex-direction: column;
      // justify-content: space-between;

      //////装按钮的区域
      .box-button {
        width: 100%;
        margin-bottom: 16px;
        // border: 1px solid red;
        display: flex;
        justify-content: space-between;
        .box-itemButton {
          width: 74px;
          // border: 1px solid blue;
          display: flex;
          justify-content: center;
          :deep(.el-button.el-button--success) {
            width: 74px;
            height: 31px;
            // border: 1px solid blue;
            // margin:0 auto !important;
            > span {
              font-size: 14px;
              font-weight: 400;
            }
          }
        }
      }
      //////装所有图书卡片组件的区域
      .box-columnBookCards {
        // height: 321px;
        height: 337px;
        display: flex;
        justify-content: space-between;
        position: relative;
        // overflow: hidden;
        // border: 1px solid red;
        //////图书卡片组件
        :deep(.column-book3) {
          width: 168px;
          // width: 100%;
          // height: 473px;
          border-radius: 8px;
          // border: 1px solid blue;
          // margin: 0 7px;

          width: 95%;
          margin: 0 auto;
          /* 
          
          思路：
          1、给swiper组件设置三个属性
          :slidesOffsetBefore="0"
          :slidesOffsetAfter="0"
          :spaceBetween="0"
          这样的话，swiper-slide就会完全充满swiper-wrapper与swiper，没有任何缝隙
          2、给swiper-slide里面的根元素设置宽度width:85%;margin:0 auto;这样就会出现视觉上的空白区域，并且因为外边距样式而居中。
          
          */

          flex-shrink: 0;
          overflow: hidden; /* 确保超出容器的内容被裁剪 */
          // white-space: nowrap; /* 确保文本在一行内显示 */
          text-overflow: ellipsis; /* 超出部分显示省略号 */
          // .big-img {
          //   width: 100%;
          //   height: 303px;
          //   // margin-bottom: 30px;
          //   // box-shadow: 0px 4px 4px 0px #00000040;
          //   // border-radius: 8px;
          //   // border: 1px solid red;
          // }
          .back-box {
            width: 163px;
            height: 163px;
            // display: flex;
            // justify-content: center;
            // align-items: center;
            .big-img {
              // width: 165px;
              // margin-left: 70px;
              // margin-top: 45px;
            }
          }
          .box-content {
            // width: 285px;
            height: 140px !important;
            // background: linear-gradient(180deg, #5fba45 24.06%, #c7db0f 100%);
            background: linear-gradient(180deg, #21a44f 10.06%, #e3f06c 100%);
            padding: 10px;
            margin-top: -5px;
            // width: 100%;

            > p:nth-of-type(1) {
              font-size: 16px;
              // font-weight: 700;
              //  letter-spacing: 1px;
              color: #ffffff;
              // border:1px solid red;
              // white-space: nowrap !important; //不折行
              // text-overflow: ellipsis !important; //文本溢出 用省略号显示
              // overflow: hidden !important;
            }
            // > p:nth-of-type(2) {
            //   font-size: 14px;
            //   font-weight: 400;
            //   color: #ffffff;
            //   line-height: 22px;
            //   display: -webkit-box;
            //   -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
            //   text-overflow: ellipsis; //文本溢出 用省略号显示
            //   -webkit-line-clamp: 5; //几行
            //   overflow: hidden;
            // }
          }
        }

        //   :deep(.swiper.swiper-initialized.swiper-horizontal.swiper-ios.inside-cardBox){
        //   border: 1px solid rgb(13, 0, 255);
        // }

        :deep(.swiper-button-prev::after) {
          margin-left: -18px;
          color: #87968c;
          font-size: 20px;
          margin-top: 0px;
          border: 1px solid #87968c;
          width: 25px;
          height: 25px;
          border-radius: 100%;
          line-height: 25px;
          text-align: center;
        }
        :deep(.swiper-button-next::after) {
          margin-right: -20px;
          color: #87968c;
          font-size: 20px;
          margin-top: 0px;
          border: 1px solid #87968c;
          width: 25px;
          height: 25px;
          border-radius: 100%;
          line-height: 25px;
          text-align: center;
        }

        .l-btn {
          position: absolute;
          z-index: 9999;
          color: #87968c;
          font-size: 20px;
          border: 1px solid #87968c;
          width: 25px;
          height: 25px;
          border-radius: 100%;
          line-height: 25px;
          text-align: center;
          top: 40%;
          left: 0px;
          background: transparent;
          z-index: 4;
        }

        .r-btn {
          position: absolute;
          z-index: 9999;
          color: #87968c;
          font-size: 20px;
          border: 1px solid #87968c;
          width: 25px;
          height: 25px;
          border-radius: 100%;
          line-height: 25px;
          text-align: center;
          top: 40%;
          right: 0px;
          background: transparent;
          z-index: 4;
        }

      }
    }

    :deep(.swiper-wrapper) {
      // border: 1px solid rgb(255, 0, 242);
      // margin:0 auto;

      width: 343px;
      // height: 484px;
      // margin-top:100px;
    }
  }

  // .subject-button {
  //   width: 1202px !important;
  //   // height: 397px;
  //   border: 1px solid rgb(0, 115, 255);
  //   background-color: #ffffff;
  //   margin: 0 auto;
  //   margin-top: 61px;
  //   padding: 20px 14px 33px 14px;
  //   overflow: hidden;
  // }

  // .tests-Card {
  //   width: 1202px !important;
  //   // height: 397px;
  //   border: 1px solid rgb(217, 255, 0);
  //   margin: 0 auto;
  //   margin-top: 32px;
  //   margin-bottom: 45px;
  //   display: flex;
  //   flex-wrap: wrap;
  //   justify-content: space-between;
  //   align-content: space-between;
  //   ; //行间距 （控制折行后的行间距）
  //   /* flex-start
  //      flex-end;
  //      center;
  //      space-between;
  //      space-around; */

  // }

  //////////分页
  //   .paging{
  //     margin:0 auto;
  //     display: flex;

  //     :deep(.el-button.is-plain){
  //       margin-left:24px;
  //     }
  //   }

  //   .demo-pagination-block + .demo-pagination-block {
  //   margin-top: 10px;
  // }
  //   .demo-pagination-block .demonstration {
  //   margin-bottom: 16px;
  // }

  // .box-bottom{
  //    position:fixed;
  //     bottom:0px;
  // }

  // .book{
  //   height:1000px;
  // }

  /* 
  
  
  
  【多选框那一快的逻辑不要改】
  就是现在的逻辑

  要不选择某几个课程
  要不选择全部课程【那现在是点击全部是取消的意思，并不是全部都选】

  不是抖音上面  你树洞额那个样子
  【多选框那一快的逻辑不要改】


  好了  就这些



  
  */
}

:deep(
    .swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets.swiper-pagination-horizontal
  ) {
  display: none;
}
</style>
